import { useEffect, useMemo, useRef } from 'react'
import ReactQuill from 'react-quill'
import 'react-quill/dist/quill.snow.css'
import './RichTextEditor.css'

const defaultModules = {
  toolbar: [
    ['bold', 'italic', 'underline', 'strike'],
    ['blockquote'],
    [{ header: 1 }, { header: 2 }],
    [{ list: 'ordered' }, { list: 'bullet' }],
    [{ direction: 'rtl' }],
    [{ size: ['small', false, 'large', 'huge'] }],
    [{ header: [1, 2, 3, 4, 5, 6, false] }],
    [{ color: [] }, { background: [] }],
    [{ font: [] }],
    [{ align: [] }],
    ['clean', 'link'],
  ],
}

function stripHtml(html = '') {
  const el = document.createElement('div')
  el.innerHTML = html
  return (el.textContent || el.innerText || '').replace(/\u200B/g, '').trim()
}

/**
 * ادیتور متن غنی با راست‌چین پیش‌فرض و شمارنده کاراکتر
 */
export default function RichTextEditor({
  value = '',
  onChange,
  modules,
  maxLength,
  className = '',
  placeholder,
}) {
  const quillRef = useRef(null)
  const rtlApplied = useRef(false)
  const resolvedModules = useMemo(() => modules || defaultModules, [modules])

  const htmlLength = value ? String(value).length : 0
  const textLength = stripHtml(value).length
  const overLimit = typeof maxLength === 'number' && htmlLength > maxLength

  useEffect(() => {
    const editor = quillRef.current?.getEditor?.()
    if (!editor || rtlApplied.current) return

    const applyRtl = () => {
      editor.format('direction', 'rtl')
      editor.format('align', 'right')
      if (editor.root) {
        editor.root.setAttribute('dir', 'rtl')
        editor.root.classList.add('ql-rtl')
      }
      rtlApplied.current = true
    }

    // اگر محتوا خالی است، جهت پیش‌فرض را ست کن
    if (!stripHtml(value)) {
      applyRtl()
    } else if (editor.root) {
      editor.root.setAttribute('dir', 'rtl')
      editor.root.classList.add('ql-rtl')
      rtlApplied.current = true
    }
  }, [value])

  return (
    <div className={`richTextEditor ${className}`.trim()}>
      <ReactQuill
        ref={quillRef}
        theme="snow"
        value={value}
        onChange={onChange}
        modules={resolvedModules}
        placeholder={placeholder}
      />
      <div className={`richTextEditor__counter ${overLimit ? 'is-over' : ''}`}>
        <span>
          متن: {textLength.toLocaleString('fa-IR')} کاراکتر
        </span>
        <span>
          کل (با HTML): {htmlLength.toLocaleString('fa-IR')}
          {typeof maxLength === 'number' ? ` / ${maxLength.toLocaleString('fa-IR')}` : ''}
        </span>
      </div>
    </div>
  )
}
